import { render, staticRenderFns } from "./launch-product.vue?vue&type=template&id=d6bbf120&scoped=true"
import script from "./launch-product.vue?vue&type=script&lang=js"
export * from "./launch-product.vue?vue&type=script&lang=js"
import style0 from "./launch-product.vue?vue&type=style&index=0&id=d6bbf120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bbf120",
  null
  
)

export default component.exports